module.exports = __webpack_public_path__ + "img/tx2.d3d55442.png";